import React, { useMemo } from 'react';
import classes from './HashtagCounter.module.scss';
import classNames from 'classnames';
import { Tooltip } from '../../../../components/actions/Tooltip';
import { idGenerator } from 'helpers/idGenerator';
import scssVars from '../../../../assets/scss/exportedVars.module.scss';

export type HashtagCounterViewProps = {
  //
  hashtagLimit: number;
  hashtagsCount: number;
};

export const HashtagCounterView = (props: HashtagCounterViewProps): JSX.Element => {
  const { hashtagLimit, hashtagsCount } = props;
  const id = useMemo(() => idGenerator('hashtagCounter'), []);
  const counterClasses = classNames(classes.HashtagCounter, {
    [classes.OffLimit]: hashtagsCount > hashtagLimit
  });

  return (
    <>
      <Tooltip
        target={`#hashtagCounter${id}`}
        type={'regular'}
        autoZIndex={false}
        style={{ zIndex: scssVars['z-index-overmodal'] }}>
        Remaining Instagram hashtags
      </Tooltip>
      <div id={`hashtagCounter${id}`} className={counterClasses}>{`#${hashtagsCount}/${hashtagLimit}`}</div>
    </>
  );
};
